module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-card"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('card-n', {
    attrs: {
      "columns": 5,
      "showBullets": true
    }
  }, [_c('Dropdown', {
    attrs: {
      "slot": "actionBullets",
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'bottom'
    },
    slot: "actionBullets"
  }, [_c('PaymentMethodButtons', {
    attrs: {
      "item": _vm.item
    },
    on: {
      "refresh": function($event) {
        return _vm.$emit('itemUpdated')
      }
    }
  })], 1), _c('payment-method-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item,
      "fieldName": 'payment-method-id'
    },
    slot: "n1"
  }), _c('payment-method-fields', {
    attrs: {
      "slot": "n2",
      "item": _vm.item,
      "fieldName": 'payment-method-name'
    },
    slot: "n2"
  }), _c('payment-method-fields', {
    attrs: {
      "slot": "n3",
      "item": _vm.item,
      "fieldName": 'payment-method-provider'
    },
    slot: "n3"
  }), _c('payment-method-fields', {
    attrs: {
      "slot": "n4",
      "item": _vm.item,
      "fieldName": 'payment-method-created'
    },
    slot: "n4"
  }), _c('payment-method-fields', {
    attrs: {
      "slot": "n5",
      "item": _vm.item,
      "fieldName": 'payment-method-updated'
    },
    slot: "n5"
  })], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-531d79a0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/PaymentMethod.vue
// module id = 2495
// module chunks = 1